import React from 'react';
import QuickRepliesSettings from '../features/settings/quick-replies/QuickRepliesSettings';

const QuickRepliesSettingsPage: React.FC = () => {
    return <QuickRepliesSettings />;
};

export default QuickRepliesSettingsPage;
